/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IReports = DealerwareWebComponents.IReportsConfiguration
    import Languages = DealerwareWebComponents.Languages

    getDealerwareWebComponentsModule()
        .constant(
            'apiToGridMapTolls', {
                'amount': 'toll_expenses'
            }
        );

    export class ReportsTollsDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$q',
            'apiToGridMapTolls',
            'DealerwareTollCollection',
            '$dealerwareNotification',
            'DataUtils',
            '$state',
            '$filter',
            '$controller',
            'uiGridConstants',
            '$dealerwareInternationalizationData'
        ];

        private reports                 : any = { };
        private gridColumns             : any;
        private dateInputTemplate       : any;

        private defaultGridSorts        : any = {
            sort_by         : 'reported_at',
            sort_direction  : 'desc'
        };

        private exportDataLoadedDefer: ng.IDeferred<any> = this.$q.defer();

        private configuration           : IReports;

        public labels                   : {};

        constructor(
            private $scope                               : ng.IScope,
            private $q                                   : ng.IQService,
            private apiToGridMapTolls                    : any,
            private DealerwareTollCollection             : any,
            private $dealerwareNotification              : any,
            private DataUtils                            : any,
            private $state                               : any,
            private $filter                              : any,
            private $controller                          : any,
            private uiGridConstants                      : any,
            public $dealerwareInternationalizationData   : any
        ) {
            this.getLabels('vehicles');
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.columnHeaders);
                    _self.initColumns();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public initColumns() : void {
            var that = this;

            var filterHeaderHtml = '<div class="report-filter-button-container">'
                + '<md-button class="md-icon-button" style="margin: 0;" aria-label="Refresh" '
                + 'ng-click="col.colDef.showModal(this)">'
                + '<md-icon md-svg-icon="filter" class="icon-filter"></md-icon>'
                + '</md-button>'
                + '</div>';

            this.dateInputTemplate = 'dealerware-tolls-date-input-filter';

            this.gridColumns = [

                {
                    name            : 'VIN',
                    displayName     : that.labels.columnHeaders.vin,
                    field           : 'vin',
                    renderHtml      : true,
                    formatCallback  : function () {

                        return that.reports.dataUtils.isBlank(this.vin) ? '' :
                            '<a class="reports-tolls-table-cell-vin" href="' + that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.car_id }
                            ) + '">' + this.vin + '</a>'
                    },
                    width           : 175
                },

                {
                    name            : 'Stock #',
                    displayName     : that.labels.columnHeaders.stock_number,
                    field           : 'stock_number',
                    enableFiltering : false
                },

                {
                    name            : 'License Plate',
                    displayName     : that.labels.columnHeaders.license_plate,
                    field           : 'license',
                    renderHtml      : true,
                    formatCallback  : function () {

                        return that.reports.dataUtils.isBlank(this.license) ? '' :
                            '<a class="reports-tolls-table-cell-license-plate" href="' + that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.car_id }
                            ) + '">' + this.license.toUpperCase() + '</a>'
                    }
                },

                {
                    name            : 'Transponder ID',
                    displayName     : that.labels.columnHeaders.transponder_id,
                    field           : 'transponder'
                },

                {
                    name            : 'Tolled At',
                    displayName     : that.labels.columnHeaders.tolled_at,
                    field           : 'tolled_at',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.tolled_at) {
                            return that.reports.dataUtils.formatDateSimple(this.tolled_at)
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.tolled_at, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        that.genericDateInputModal.call (
                            that, columnScope, 'tolled_at'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Tolled At Time Zone',
                    displayName     : that.labels.columnHeaders.tolled_at_time_zone,
                    field           : 'tolled_at_timezone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.tolled_at ? that.reports.timeZoneCode : '';
                    }
                },



                /*

                {
                    name            : 'Tolled At',
                    field           : 'tolled_at',
                    formatCallback  : function () {
                        return that.reports.dataUtils.formatTimestampSimple(
                            this.tolled_at, that.reports.timeZone
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        that.genericDateInputModal.call (
                            that, columnScope, 'tolled_at'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },
                */





                {
                    name            : 'Reported At',
                    displayName     : that.labels.columnHeaders.reported_at,
                    field           : 'reported_at',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.reported_at) {
                            return that.reports.dataUtils.formatDateSimple(this.reported_at)
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.reported_at, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        that.genericDateInputModal.call (
                            that, columnScope, 'reported_at'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Reported At Time Zone',
                    displayName     : that.labels.columnHeaders.reported_at_time_zone,
                    field           : 'reported_at_timezone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.reported_at ? that.reports.timeZoneCode : '';
                    }
                },




                /*
                {
                    name            : 'Reported At',
                    field           : 'reported_at',
                    formatCallback  : function () {
                        return that.reports.dataUtils.formatTimestampSimple(
                            this.reported_at, that.reports.timeZone
                        );
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {
                        that.genericDateInputModal.call (
                            that, columnScope, 'reported_at'
                        );
                    },
                    filterHeaderTemplate: filterHeaderHtml
                },
                */

                {
                    name            : 'Contract ID',
                    displayName     : that.labels.columnHeaders.contract_id,
                    field           : 'reservation_confirmation_token',
                    renderHtml      : true,
                    formatCallback  : function () {

                        return that.reports.dataUtils.isBlank(this.reservation_confirmation_token) ? '' :
                            '<a class="reports-tolls-table-cell-contract-id" href="' + that.$state.href('root.private.application.contracts.details',
                            { contractId: this.reservation_id }
                            ) + '">' + this.reservation_confirmation_token + '</a>';
                    }
                },

                {
                    name            : 'Toll Type',
                    displayName     : that.labels.columnHeaders.toll_type,
                    field           : 'toll_type',
                    filter: {
                        type: that.uiGridConstants.filter.SELECT,
                        selectOptions: [
                            { value: 'Non-Contract',label: 'Non-Contract' },
                            { value: 'Contract',    label: 'Contract' },
                            { value: 'Late',        label: 'Late' }
                        ]
                    }
                },

                {
                    name            : 'Amount',
                    displayName     : that.labels.columnHeaders.amount,
                    field           : 'toll_expenses',
                    formatCallback  : function () {
                        return that.getCurrencyLabel(this.amount);
                    },
                    cellClass       : 'ui-grid-cell-contents-number',
                    showModal       : function ( columnScope: any ) {
                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'gteq',
                                startRange  : 10
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'toll_expenses';

                        that.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : filterField,
                            template                : 'dealerware-tolls-numeric-filter',
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : that.reports.calculateNumericFilter
                        });
                        that.reports.showFilterModal(filterField);
                    },

                    filterHeaderTemplate: filterHeaderHtml
                },

                {
                    name            : 'Description',
                    displayName     : that.labels.columnHeaders.description,
                    field           : 'description',
                    enableFiltering : false
                }
            ];

            this.setReportsConfiguration();
        }

        private getCurrencyLabel(value: string): string {
            if(localStorage.getItem('language') === this.$dealerwareInternationalizationData.FR) {
                return `${value} $`;
            }
            return this.reports.dataUtils.formatCurrencySimple(value);
        }

        public loadAllDataForExport ( ) : ng.IPromise<any> {
            return this.reports.loadAllDataForExport();
        }

        public genericDateInputModal ( columnScope: any, apiField: string, columnField?: string ) : void {

            var that = this;

            columnField = columnField || apiField;

            if (! columnScope.col.modalData) {
                columnScope.col.modalData = {
                    monthYearDate : moment().toDate()
                };
            }

            columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

            var filterField = apiField;

            that.reports.setFilterControlData(filterField, {
                title                   : columnScope.col.name,
                field                   : columnField,
                template                : that.dateInputTemplate,
                gridColumn              : columnScope.col,
                calculateFilterFunction : that.reports.calculateDateInputFilter
            });

            that.reports.showFilterModal(filterField);
        }

        public setReportsConfiguration () : void {

            var that = this;

            // This report's configuration.
            //
            this.configuration = {
                grid        : {
                    defaultSorts    : this.defaultGridSorts,
                    defaultFilters  : {},
                    columnMap       : this.apiToGridMapTolls,
                    columns         : this.gridColumns
                },
                collection  : {
                    model           : this.DealerwareTollCollection,
                    loadMethod      : 'tolls'
                },
                $scope              : this.$scope
            };

            // Add base controller members to this report.
            //
            this.reports = this.$controller('ReportsController', {
                thisReportConfiguration : this.configuration,
                '$scope'                : this.$scope
            });

            // CSV config uses bases ReportsController methods for dataLoading,
            // but they could be custom for this report.
            //
            var exportFileName = 'tolls_' + moment().format('YYYY_MM_DD') + '.csv';
            this.configuration.csvExport = {
                showExporterMenu    : false,
                thisPage    : {
                    fileName        : exportFileName,
                    dataLoadMethod  : this.reports.loadThisPageDataForExport
                },
                allPages    : {
                    fileName        : exportFileName,
                    dataLoadMethod  : ( ) => {
                        return this.loadAllDataForExport.call (that);
                    },
                }
            };

            // Update the export filename to add location name after the location has loaded
            //
            var cancelExportedCsvFileNameWatcher = this.$scope.$watch(() => {
                return this.reports.locationName;
            }, (locationName: string) => {
                if (locationName) {
                    this.setExportedCsvFileName();
                    cancelExportedCsvFileNameWatcher();
                }
            });
        }

        public setExportedCsvFileName () : void {
            if (this.reports.locationName) {
                var exportFileNamePrefix = this.$filter('spaceless')(this.reports.locationName.toLowerCase());

                var currentFilename = this.configuration.csvExport.thisPage.fileName;
                this.configuration.csvExport.thisPage.fileName = exportFileNamePrefix + '_' + currentFilename;
                this.configuration.csvExport.allPages.fileName = exportFileNamePrefix + '_' + currentFilename;
            }
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ReportsTollsDirectiveController',
        ReportsTollsDirectiveController
    );


    export class ReportsTollsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ReportsTollsDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/reports/tolls/tolls-directive.html';
        public scope            : Object    =   { };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareReportsTolls',
        ( ) => new ReportsTollsDirective()
    );

}

